export function replaceString(
    text: string,
    terms: Record<string, any> = {}
): string {
    let textCopy = text;
    for (const keyword in terms) {
        if (Object.hasOwnProperty.call(terms, keyword)) {
            textCopy = textCopy.replace(keyword, terms[keyword]);
        }
    }
    return textCopy;
}
